<template>
  <div class="mobile-index-box margin-top">
    <div class="total-bg">
      <div class="total-item">
        <p>服务对象</p>
        <p><b>{{ served_num }}</b> 名</p>
      </div>
      <div class="total-item">
        <p>社区(村)</p>
        <p><b>{{ shequ_num }}</b> 个</p>
      </div>
      <div class="total-item">
        <p>街道(乡镇)</p>
        <p><b>{{ jiedao_num }}</b> 个</p>
      </div>
      <div class="total-item">
        <p>区域</p>
        <p><b>{{ quyu_num }}</b> 个</p>
      </div>
    </div>
    <div class="next-btn" @click="toNext(2)">下一页</div>
  </div>
</template>

<script>
import {phoneDateOne} from "@/api/weilao";

export default {
  name: "totalPage",
  data() {
    return {
      served_num: 0,
      shequ_num: 0,
      jiedao_num: 0,
      quyu_num: 0,
    }
  },
  created() {
    this.init()
  },
  components: {},
  methods: {
    async init() {
      const res = await phoneDateOne()
      this.served_num = res.data.served_num
      this.shequ_num = res.data.shequ_num
      this.jiedao_num = res.data.jiedao_num
      this.quyu_num = res.data.quyu_num
    },
    toNext(num) {
      this.$emit('toNext', num)
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.mobile-index-box {
  min-height: calc(100vh - 150px);

  .total-bg {
    background: url(../../../assets/img/mobile/mobile-db.png) no-repeat top center;
    background-size: 100% 100%;
    padding: 30px 20px;

    .total-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url(../../../assets/img/mobile/mobile-info-bg.png) no-repeat top center;
      background-size: 100% 100%;
      padding: 40px 30px 30px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        font-size: 20px;
        line-height: 150%;

        b {
          font-size: 26px;
          color: #fc3333;
          font-weight: 500;
          font-style: italic;
        }
      }
    }
  }

  .next-btn {
    width: 50%;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin: 30px auto 0;
    font-size: 16px;
    color: #f84e4e;
  }
}
</style>
